module.exports = __webpack_public_path__ + "static/media/588.0798408e.webp";